import { useEffect } from "react";
import { useAuthStore } from "../../store";
import { useStage4NotificationsStore } from "../../store/useStage4NotificationsStore";

// A single app-level connection keeps Stage-4 events alive across navigation.
export default function Stage4JobsManager() {
  const accessToken = useAuthStore((state) => state.accessToken);
  const loadNotifications = useStage4NotificationsStore((state) => state.load);

  useEffect(() => {
    if (!accessToken) return undefined;
    loadNotifications().catch(() => undefined);
    const apiUrl = (
      process.env.REACT_APP_NEW_CAPTABLE_API || "http://localhost:4000"
    ).replace(/\/$/, "");
    const events = new EventSource(
      `${apiUrl}/v1/taskManager/reconstruct-stage4/events?accessToken=${encodeURIComponent(
        accessToken.replace(/^Bearer\s+/i, "")
      )}`
    );
    const onBatchEvent = (event: MessageEvent) => {
      const payload = JSON.parse(event.data || "{}");
      // Job-completion events do not consistently include the batch ID. The
      // active Stage-4 page already knows its batch ID, so signal every state
      // change and let it re-read that canonical server record.
      window.dispatchEvent(
        new CustomEvent("stage4-batch-updated", { detail: { payload } })
      );
      loadNotifications().catch(() => undefined);
    };
    [
      "STAGE4_COMPLETED",
      "STAGE4_FAILED",
      "STAGE4_BATCH_QUEUED",
      "STAGE4_BATCH_COMPLETED",
      "STAGE4_BATCH_COMPLETED_WITH_ERRORS",
      "STAGE4_BATCH_FAILED",
    ].forEach((name) => events.addEventListener(name, onBatchEvent as any));
    return () => events.close();
  }, [accessToken, loadNotifications]);

  return null;
}
